import React from "react";
import blickImg from "../../assets/images/common/blick_1.png";
import loader from "../../assets/images/common/spiner.gif";
import { textNodes } from "../../styles";

const Button = ({
  blick,
  text,
  action,
  icon,
  disabledIcon,
  isButtonDisabled,
  isLoading,
  buttonStyles,
}) => {
  return (
    <div
      onClick={action}
      className={`${
        textNodes.button
      } relative flex h-14 w-full cursor-pointer items-center justify-center overflow-hidden rounded-[8px] bg-greenButton text-lightColor transition duration-300 ${
        isButtonDisabled && "pointer-events-none !bg-[#DEDEDE]"
      } ${buttonStyles}`}
    >
      {isLoading ? (
        <img className={"h-10 w-10"} src={loader} alt="loader" />
      ) : (
        <>
          {icon ? (
            <img
              className="mr-2"
              src={isButtonDisabled ? disabledIcon : icon}
              alt="icon"
            />
          ) : null}
          {text}
        </>
      )}

      {blick ? (
        <div className="absolute animate-blick">
          <img src={blickImg} alt="blick" />
        </div>
      ) : null}
    </div>
  );
};

export default Button;
